import React, { useState, useEffect } from "react";

export default function UseServiceOverview() {
    const [size, setSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
      });
      const updateSize = () =>
        setSize({
          width: window.innerWidth,
          height: window.innerHeight,
        });
      useEffect(() => (window.onresize = updateSize), []);
    const userTableHeadings = [
        'Username',
        'Password',
        'Certificate',
        'Certificate Vaildity',
        '',
    ];
    const aclTableHeadings = [
        'Username',
        'Topic',
        'Permission',
        'Remove',
    ];
    const aclData = [
        {
            userName: 'Adminomar',
        },
        {
            userName: 'Adminomar',
        },
        {
            userName: 'Adminomar',
        },
    ]
    return [{ userTableHeadings, aclTableHeadings, aclData,size }]
}
